import axios from "axios";
import Cookies from "js-cookie";
import { refreshToken } from "./axios-refresh";
import { UserRole } from "@/utils/enums";
import { authStore } from "@/pages/Login/store";
import { logoutHandler } from "@/auth/logout";
import { envVars } from "@/envVars";
import { paths } from "@/navigation/paths";

const axiosClient = axios.create({
  baseURL: envVars.API_BASE_URL,
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json",
  },
});

axiosClient.interceptors.request.use((request) => {
  const { user } = authStore.getState();
  if (user && user.role !== UserRole.RECIPIENT) {
    logoutHandler();
  }

  const token = Cookies.get("token");
  if (token) {
    const Authorization = `Bearer ${token}`;
    request.headers.set("Authorization", Authorization);
  }

  // Tells the backend which client acted, so a booking made here is
  // distinguishable from one made in the mobile app. Both reach the same
  // endpoints with the same auth, so nothing else separates them.
  request.headers.set("x-boxxy-client", "user_dashboard");

  return request;
});

axiosClient.interceptors.response.use(
  (response) => response,
  async (err) => {
    const originalRequest = err.config;
    if (err.response?.status === 404) {
      window.location.replace(paths.NOT_FOUND);
      return Promise.reject(err);
    }

    if (
      err.response?.status === 401 &&
      originalRequest &&
      !originalRequest._hasRetriedRequest
    ) {
      originalRequest._hasRetriedRequest = true;

      await refreshToken();
      return axiosClient(originalRequest);
    }

    if (err.response?.status === 401) {
      logoutHandler();
      return Promise.reject(err);
    }

    return Promise.reject(err);
  }
);

export default axiosClient;
